import React from 'react';
import MainRouter from './router';

function App() {
  return (<MainRouter/>)
}

export default App;